import type { PerUnitProductVariant } from '@weft/services';
import cn from 'classnames';
import React from 'react';
import { PerUnitUsageChargeForm } from '../../PerUnitUsageCharge/per-unit-usage-charge-components/PerUnitUsageChargeForm';

type PerUnitUsageChargeEditVariantsListItemProps = {
  variant: PerUnitProductVariant;
  productIndex: number;
  variantIndex: number;
};

export const PerUnitUsageChargeEditVariantsListItem: React.FC<PerUnitUsageChargeEditVariantsListItemProps> = ({ variant, productIndex, variantIndex }) => {
  return (
    <div
      key={variant.id}
      className={cn('pt-8', { 'first': variantIndex === 0 })}
    >
      <PerUnitUsageChargeForm
        productIndex={productIndex}
        productVariant={variant}
        productVariantIndex={variantIndex}
      />
    </div>
  );
};